import { Role } from './role';

export interface UserRole {
  id?: number;
  name?: string;
}

export interface AuthSession {
  token: string;
}

export class User {
  id: number;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  avatar: string;
  role: Role;
}

export interface CurrentUser extends User {
  roles: Array<Role | UserRole>;
}
